
import Redo from "@aomao/plugin-redo";
import Undo from "@aomao/plugin-undo";
import Bold from "@aomao/plugin-bold";
import Code from "@aomao/plugin-code";
import Backcolor from "@aomao/plugin-backcolor";
import Fontcolor from "@aomao/plugin-fontcolor";
import Fontsize from "@aomao/plugin-fontsize";
import Italic from "@aomao/plugin-italic";
import Underline from "@aomao/plugin-underline";
import Hr, { HrComponent } from "@aomao/plugin-hr";
import Tasklist, { CheckboxComponent } from "@aomao/plugin-tasklist";
import Orderedlist from "@aomao/plugin-orderedlist";
import Unorderedlist from "@aomao/plugin-unorderedlist";
import Indent from "@aomao/plugin-indent";
import Heading from "@aomao/plugin-heading";
import Strikethrough from "@aomao/plugin-strikethrough";
import Sub from "@aomao/plugin-sub";
import Sup from "@aomao/plugin-sup";
import Alignment from "@aomao/plugin-alignment";
import Quote from "@aomao/plugin-quote";
import PaintFormat from "@aomao/plugin-paintformat";
import RemoveFormat from "@aomao/plugin-removeformat";
import SelectAll from "@aomao/plugin-selectall";
import Image, { ImageComponent, ImageUploader } from "@aomao/plugin-image";
import Table, { TableComponent } from "@aomao/plugin-table";
import File, { FileComponent, FileUploader } from "@aomao/plugin-file";
import Video, { VideoComponent, VideoUploader } from "@aomao/plugin-video";
import Math, { MathComponent } from "@aomao/plugin-math";
import Fontfamily from "@aomao/plugin-fontfamily";
import Status, { StatusComponent } from "@aomao/plugin-status";
import LineHeight from "@aomao/plugin-line-height";
import Mention, { MentionComponent } from "@aomao/plugin-mention";
import Link from 'am-editor-link-vue2';
import FsBtn from "../fs_btn"

import CodeBlock, { CodeBlockComponent } from 'am-editor-codeblock-vue2';
import { ToolbarPlugin, ToolbarComponent, fontFamilyDefaultData } from 'am-editor-toolbar-vue2';


import  { uploadUrl,imgShow} from "@/assets/utils/uploadUrl"
const DOMAIN = uploadUrl;
const IMG_SHOW = imgShow;

export const plugins = [
  Redo,
  Undo,
  Bold,
  Code,
  Backcolor,
  Fontcolor,
  Fontsize,
  Italic,
  Underline,
  Hr,
  Tasklist,
  Orderedlist,
  Unorderedlist,
  Indent,
  Heading,
  Strikethrough,
  Sub,
  Sup,
  Alignment,
  Quote,
  PaintFormat,
  RemoveFormat,
  SelectAll,
  Image,
  ImageUploader,
  Table,
  File,
  FileUploader,
  Video,
  VideoUploader,
  Math,
  Fontfamily,
  Status,
  LineHeight,
  Mention,
  CodeBlock,
  ToolbarPlugin,
  Link,
  FsBtn
]

export const cards = [
  HrComponent,
  CheckboxComponent,
  ImageComponent,
  TableComponent,
  FileComponent,
  VideoComponent,
  MathComponent,
  StatusComponent,
  MentionComponent,
  CodeBlockComponent,
  ToolbarComponent,
];

export const pluginConfig = {
  [Italic.pluginName]: {
    // 默认为 _ 下划线，这里修改为单个 * 号
    markdown: "*",
  },
  [ImageUploader.pluginName]: {
    file: {
      action: DOMAIN, //图片上传
      headers: {  },
      data: {
        type: 1
      }
    },
    remote: {
      action: DOMAIN, //添加外网图片连接上传,上后端下载图片，并返回一个本地连接,比如图片复制
    },
    isRemote: (src) => src.indexOf(DOMAIN) < 0,
  },
  [FileUploader.pluginName]: {  // 文件上传
    action:DOMAIN,
  },
  [VideoUploader.pluginName]: { // 视频上传
    action: DOMAIN,
    limitSize: 1024 * 1024 * 50,
  },
  [Image.pluginName]: { // 图片上传回调
    onBeforeRender: (status, url) => {
      if (url.startsWith("data:image/")) { return url };
      return (IMG_SHOW + url);
    },
  },
  [Video.pluginName]: { // 视频上传回调
    onBeforeRender: (status, url) => {
      return (IMG_SHOW + url);
    },
  },
  [Math.pluginName]: {
    action: ``,
    parse: (res) => {
      if (res.success) { return { result: true, data: res.svg } };
      return { result: false };
    },
  },
  [Fontsize.pluginName]: {
    //配置粘贴后需要过滤的字体大小
    filter: (fontSize) => {
      return (
        [
          "12px",
          "13px",
          "14px",
          "15px",
          "16px",
          "19px",
          "22px",
          "24px",
          "29px",
          "32px",
          "40px",
          "48px",
        ].indexOf(fontSize) > -1
      );
    },
  },
  [Fontfamily.pluginName]: {
    //配置粘贴后需要过滤的字体
    filter: (fontfamily) => {
      const item = fontFamilyDefaultData.find((item) =>
        fontfamily
          .split(",")
          .some(
            (name) =>
              item.value
                .toLowerCase()
                .indexOf(name.replace(/"/, "").toLowerCase()) > -1
          )
      );
      return item ? item.value : false;
    },
  },
  [LineHeight.pluginName]: {
    //配置粘贴后需要过滤的行高
    filter: (lineHeight) => {
      if (lineHeight === "14px") { return "1" };
      if (lineHeight === "16px") { return "1.15" };
      if (lineHeight === "21px") { return "1.5" };
      if (lineHeight === "28px") { return "2" };
      if (lineHeight === "35px") { return "2.5" };
      if (lineHeight === "42px") { return "3" };
      // 不满足条件就移除掉
      return ["1", "1.15", "1.5", "2", "2.5", "3"].indexOf(lineHeight) > -1;
    },
  },
  toolbar: {
    popup: {
      items: [
        ["bold", "strikethrough", "fontcolor"],
        {
          icon: "text",
          items: ["italic", "underline", "backcolor", "moremark"],
        },
        [
          {
            type: "button",
            name: "image-uploader",
            icon: "image",
          },
          "link",
          "tasklist",
          "heading",
        ],
        {
          icon: "more",
          items: [
            {
              type: "button",
              name: "video-uploader",
              icon: "video",
            },
            {
              type: "button",
              name: "file-uploader",
              icon: "attachment",
            },
            {
              type: "button",
              name: "math",
              icon: "math",
            },
            {
              type: "button",
              name: "codeblock",
              icon: "codeblock",
            },
            {
              type: "button",
              name: "orderedlist",
              icon: "ordered-list",
            },
            {
              type: "button",
              name: "unorderedlist",
              icon: "unordered-list",
            },
            {
              type: "button",
              name: "hr",
              icon: "hr",
            },
          ],
        },
      ],
    },
  },
}

export const itemConfig = [
  [
    {
      type: "collapse",
      groups: [
        {
          items: [
            "image-uploader",
            "codeblock",
            "table",
            // "file-uploader",
            // "video-uploader",
            "math",
            "status",
          ],
        },
      ],
    },
  ],
  ["undo", "redo", "paintformat", "removeformat"],
  ["heading", "fontfamily", "fontsize"],
  ["bold", "italic", "strikethrough", "underline", "moremark"],
  ["fontcolor", "backcolor"],
  ["alignment"],
  ["unorderedlist", "orderedlist", "tasklist", "indent", "line-height"],
  ["link", "quote", "hr"],
  [
		{
      type: "button",
			name: 'FsBtn',
      className: "fullScreenButton",
			content: '全屏切换',
		},
	],
]



// WEBPACK FOOTER //
// ./src/components/mk-editor/config/config.js